import Vue from 'vue';
import Router from 'vue-router';
import {
  Login, Register,
  // RegisterBackups, RegisterCloud, RegisterAecc, RegisterCoupon, RegisterCinco, RegisterSuite,
  Recover, Files, Bin, Cloud, Secret, Bak, SharedDrives, SharedWithMe, Drive, MyUnits, Archived, Transfers, UploadTransfers, 
  DownloadTransfers, Share, Folder, Join, Inbox, NewRecord, Record, Profile, Info, Settings, Invoicing, Account,
  Layout, Plans, Promo, Contact, Dealers, /*Referrals,*/ Resellers, TransactionOk, TransactionError,
  SharedFolders,
  Error403, Error404, Error500,
} from '@/views';

import store from '@/store';
import { baseURL } from '@/utils/constants';

Vue.use(Router);

export const ROUTES = {
  LOGIN: 'Login',
  REGISTER: 'Register',

  CLOUD: 'Cloud',
  SHARED_FOLDERS: 'Shared folders',
  BIN: 'Bin',
  BACKUP: 'Bak',
  SECRET: 'Secret',

  SHARED_DRIVES: 'Shared drives',
  MY_SHARED_DRIVES: 'My Units',
  SHARED_WITH_ME: 'Shared With Me',
  ARCHIVED: 'Archived',
  DRIVE: 'Drive',

  TRANSFERS: 'Transfers',
  UPLOADS: 'Upload Transfers',
  DOWNLOADS: 'Download Transfers',

  PROFILE: 'Profile',
  INFO: 'Information',
  SETTINGS: 'Settings',
  ACCOUNT: 'Account',
  INVOICING: 'Invoicing',

  RECOVER: 'Recover',
  JOIN: 'Join',
  SHARED_FILE: 'Shared file',
  SHARED_FOLDER: 'Shared folder',

  ERROR_403: '403',
  ERROR_404: '404',
  ERROR_500: '500',
};

//Aqui se ponen las rutas 
const router = new Router({
  base: baseURL,
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: ROUTES.LOGIN,
      component: Login,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLogged) {
          return next({ name: ROUTES.CLOUD });
        }

        document.title = 'Login';
        next();
      }
    },
    {
      path: '/register',
      name: ROUTES.REGISTER,
      component: Register,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLogged) {
          return next({ name: ROUTES.CLOUD });
        }

        document.title = 'Register';
        next();
      }
    },
    // {
    //   path: '/register-backup',
    //   name: 'Register Backups',
    //   component: RegisterBackups,
    //   beforeEnter: (to, from, next) => {
    //     if (store.getters.isLogged) {
    //       return next({ name: ROUTES.BACKUP });
    //     }

    //     document.title = 'Register Backup';
    //     next();
    //   }
    // },
    // {
    //   path: '/register-cloud',
    //   name: 'Register Cloud',
    //   component: RegisterCloud,
    //   beforeEnter: (to, from, next) => {
    //     if (store.getters.isLogged) {
    //       return next({  name: ROUTES.CLOUD });
    //     }

    //     document.title = 'Register Cloud';
    //     next();
    //   }
    // },
    // {
    //   path: '/register-solidaria-aecc',
    //   name: 'Register Aecc',
    //   component: RegisterAecc,
    //   beforeEnter: (to, from, next) => {
    //     if (store.getters.isLogged) {
    //       return next({  name: ROUTES.CLOUD });
    //     }

    //     document.title = 'Register Aecc';
    //     next();
    //   }
    // },
    // {
    //   path: '/register-suite-coupon',
    //   name: 'Register Coupon',
    //   component: RegisterCoupon,
    //   beforeEnter: (to, from, next) => {
    //     if (store.getters.isLogged) {
    //       return next({  name: ROUTES.CLOUD });
    //     }

    //     document.title = 'Register Coupon';
    //     next();
    //   }
    // },
    // {
    //   path: '/register-suite-cinco',
    //   name: 'Register Cinco',
    //   component: RegisterCinco,
    //   beforeEnter: (to, from, next) => {
    //     if (store.getters.isLogged) {
    //       return next({  name: ROUTES.CLOUD });
    //     }

    //     document.title = 'Register Cinco';
    //     next();
    //   }
    // },
    // {
    //   path: '/create-account',
    //   name: 'Register Suite',
    //   component: RegisterSuite,
    //   beforeEnter: (to, from, next) => {
    //     if (store.getters.isLogged) {
    //       return next({  name: ROUTES.CLOUD });
    //     }

    //     document.title = 'Register Suite';
    //     next();
    //   }
    // },
    {
      path: '/promo',
      name: 'Promo',
      component: Promo,
      beforeEnter: (to, from, next) => {
        document.title = 'Promo';
        next();
      }
    },
    {
      path: '/join/*',
      name: ROUTES.JOIN,
      component: Join,
    },
    {
      path: '/transaction-ok',
      name: 'TransactionOk',
      component: TransactionOk,
      beforeEnter: (to, from, next) => {
        document.title = 'Transaction OK';
        next();
      }
    },
    {
      path: '/transaction-error',
      name: 'TransactionError',
      component: TransactionError,
      beforeEnter: (to, from, next) => {
        document.title = 'Transaction error';
        next();
      }
    },
    {
      path: '/recover',
      name: ROUTES.RECOVER,
      component: Recover,
      beforeEnter: (to, from, next) => {
        if (store.getters.isLogged) {
          return next({ name: ROUTES.CLOUD });
        }

        document.title = 'Recover';
        next();
      }
    },
    {
      path: '/*',
      component: Layout,
      children: [
        {
          path: '/file/*',
          name: ROUTES.SHARED_FILE,
          component: Share
        },
        {
          path: '/folder/*',
          name: ROUTES.SHARED_FOLDER,
          component: Folder
        },
        {
          path: '/account/*',
          name: 'Contact',
          component: Contact
        },
        {
          path: '/drive/*',
          name: ROUTES.DRIVE,
          component: Drive
        },
        {
          path: '/inbox/*',
          name: 'Inbox',
          component: Inbox,
          beforeEnter: (to, from, next) => {
            let link = to.fullPath;
            ibbLink.getInboxInfo(link).then(action => {
              if (action.error.type) {
                throw new Error('Error getting inbox info: ' +  action.error.type);
              }
              localStorage.setItem('linkInbox', JSON.stringify(action));
              ibbLink.startRecord(link).then(action => {
                if (action.error.type) {
                  alert('No se puede enviar ningún mensaje a ese buzón porque tu contacto no tiene espacio en su cuenta');
                  next({ name: ROUTES.CLOUD });
                } else {
                  let newRecordLink = action.session;
                  next({ path: newRecordLink.substring(19) });
                }
              })
              .catch (e => {
                store.commit('showError', e);
              });
            })
            .catch (e => {
              store.commit('showError', e);
            });
          }
        },
        {
          path: '/new-record/*',
          name: 'NewRecord',
          component: NewRecord
        },
        {
          path: '/record/*',
          name: 'Record',
          component: Record
        },
        {
          path: '/files',
          name: 'Files',
          component: Files,
          redirect: {
            name: ROUTES.CLOUD
          },
          meta: {
            requiresAuth: true,
            requiresPermissionCloud: true
          },
          children: [
            {
              path: '/cloud',
              name: ROUTES.CLOUD,
              component: Cloud,
              meta: {
                requiresAuth: true,
                requiresPermissionCloud: true
              }
            },
            {
              path: '/shared-folders',
              name: ROUTES.SHARED_FOLDERS,
              component: SharedFolders,
              meta: {
                requiresAuth: true,
                requiresPermissionCloud: true
              }
            },
            {
              path: '/sec',
              name: ROUTES.SECRET,
              component: Secret,
              meta: {
                requiresAuth: true,
                requiresPermissionCloud: true
              }
            },
            {
              path: '/bin',
              name: ROUTES.BIN,
              component: Bin,
              meta: {
                requiresAuth: true,
                requiresPermissionCloud: true
              }
            }
          ]
        },
        {
          path: '/bak',
          name: ROUTES.BACKUP,
          component: Bak,
          meta: {
            requiresAuth: true,
            requiresPermissionBackup: true
          }
        },
        {
          path: '/shared-drive',
          name: ROUTES.SHARED_DRIVES,
          component: SharedDrives,
          redirect: {
            path: '/shared-drive/my-drives'
          },
          meta: {
            requiresAuth: true
          },
          children: [
            {
              path: '/shared-drive/my-drives',
              name: ROUTES.MY_SHARED_DRIVES,
              component: MyUnits,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: '/shared-drive/shared-with-me',
              name: ROUTES.SHARED_WITH_ME,
              component: SharedWithMe,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: '/shared-drive/archived',
              name: ROUTES.ARCHIVED,
              component: Archived,
              meta: {
                requiresAuth: true
              }
            },
          ]
        },
        {
          path: '/transfers',
          name: ROUTES.TRANSFERS,
          component: Transfers,
          redirect: {
            path: '/transfers/downloads'
          },
          meta: {
            requiresAuth: true
          },
          children: [
            {
              path: '/transfers/uploads',
              name: ROUTES.UPLOADS,
              component: UploadTransfers,
              meta: {
                requiresAuth: true
              }
            },
            {
              path: '/transfers/downloads',
              name: ROUTES.DOWNLOADS,
              component: DownloadTransfers,
              meta: {
                requiresAuth: true
              }
            }
          ]
        },
        {
          path: '/dealers',
          name: 'Dealers',
          component: Dealers,
          redirect: {
            path: '/dealers/resellers'
          },
          meta: {
            requiresReseller: true,
            requiresAuth: true
          },
          children: [
            {
              path: '/dealers/resellers',
              name: 'Resellers',
              component: Resellers,
              meta: {
                requiresReseller: true,
                requiresAuth: true
              },
            },
            // {
            //   path: '/dealers/referrals',
            //   name: 'Referrals',
            //   component: Referrals,
            //   meta: {
            //     requiresReseller: true,
            //     requiresAuth: true
            //   },
            // }
          ]
        },
        {
          path: '/profile',
          name: ROUTES.PROFILE,
          component: Profile,
          redirect: {
            path: '/profile/info'
          },
          meta: {
            requiresAuth: true
          },
          children: [
            {
              path: '/profile/settings',
              name: ROUTES.SETTINGS,
              component: Settings
            },
            {
              path: '/profile/info',
              name: ROUTES.INFO,
              component: Info,
            },
            {
              path: '/profile/account',
              name: ROUTES.ACCOUNT,
              component: Account,
            },
            {
              path: '/profile/invoicing',
              name: ROUTES.INVOICING,
              component: Invoicing,
              meta: {
                requiresNotAssociated: true
              },
            },
            {
              path: '/profile/invoicing/plans',
              name: 'Invoicing Plans',
              component: Plans,
              meta: {
                requiresNotAssociated: true
              },
            },
          ]
        },
        {
          path: '/403',
          name: ROUTES.ERROR_403,
          component: Error403
        },
        {
          path: '/404',
          name: ROUTES.ERROR_404,
          component: Error404
        },
        {
          path: '/500',
          name: ROUTES.ERROR_500,
          component: Error500
        },
        {
          path: '/*',
          redirect: { name: ROUTES.CLOUD }
        }
      ]
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  document.title = to.name;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isLogged) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });

      return;
    }

    if (to.matched.some(record => record.meta.requiresReseller)) {
      if (store.state.user.perm.reseller === 0) {
        next({ path: '/cloud' });
        return;
      }
    }

    if (to.matched.some(record => record.meta.requiresNotAssociated)) {
      if (store.state.user.perm.paymentMethod === 2) {
        next({ path: '/cloud' });
        return;
      }
    }

    if (to.matched.some(record => record.meta.requiresPermissionBmail)) {
      if (!(store.state.user.perm.features & Module.FeatureType.FEATURE_BMAIL.value)) {
        next({ path: '/profile/info' });
        return;
      }
    }

    if (to.matched.some(record => record.meta.requiresPermissionBackup)) {
      if (!(store.state.user.perm.features & Module.FeatureType.FEATURE_BACKUP.value)) {
        next({ path: '/profile/info' });
        return;
      }
    }

    if (to.matched.some(record => record.meta.requiresPermissionCloud)) {
      if (!(store.state.user.perm.features & Module.FeatureType.FEATURE_CLOUD.value)) {
        next({ path: '/profile/info' });
        return;
      }
    }
  }

  next();
});

export default router;
